<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useDataStore } from '@/stores/data'
import { useUiStore } from '@/stores/ui'
import { useAuthStore } from '@/stores/auth'
import { pageByPath } from '@/data/registry'
import AppDrawer from '@/components/ui/AppDrawer.vue'
import AppIcon from '@/components/AppIcon.vue'
import { formatDateTime } from '@/utils/format'

defineProps<{ open: boolean }>()
const emit = defineEmits<{ close: [] }>()
const data = useDataStore()
const ui = useUiStore()
const auth = useAuthStore()
const router = useRouter()
const notices = computed(() => data.notices.filter(notice => {
  const path = notice.linkRoute.replace(/^#/, '').split('?')[0] ?? ''
  const page = pageByPath(path)
  return !page || page.permission === 'public' || page.permission === 'authenticated' || auth.has(page.permission)
}))

function openNotice(id: string, route: string): void {
  const notice = notices.value.find(item => item.id === id)
  if (notice) data.markRead(id)
  emit('close')
  if (route) void router.push(route.replace(/^#/, ''))
  else ui.toast('info', '通知已读')
}

function markAll(): void {
  data.markAllRead()
  ui.toast('success', '全部通知已标记为已读')
}
</script>

<template>
  <AppDrawer :open="open" title="通知中心" subtitle="预警、任务、工单与安全通知" width="420px" @close="emit('close')">
    <div class="drawer-toolbar">
      <span class="muted">未读 {{ data.unreadCount }} 条</span>
      <button type="button" class="text-button" :disabled="!data.unreadCount" @click="markAll">全部已读</button>
    </div>
    <div v-if="!notices.length" class="empty-state">
      <span class="empty-state__art"><AppIcon name="bell" :size="34" /></span>
      <h3 class="empty-state__title">暂无通知</h3>
    </div>
    <div v-else class="notice-list">
      <button v-for="notice in notices" :key="notice.id" type="button" class="notice-row" :class="{ 'is-unread': !notice.read }" @click="openNotice(notice.id, notice.linkRoute)">
        <span class="notice-row__dot" :class="{ 'notice-row__dot--read': notice.read }" aria-hidden="true" />
        <span class="notice-row__body">
          <span class="notice-row__title">{{ notice.title }}</span>
          <span class="notice-row__text">{{ notice.body }}</span>
          <span class="notice-row__time">{{ formatDateTime(notice.createdAt) }}</span>
        </span>
        <AppIcon name="chevron-right" :size="14" />
      </button>
    </div>
  </AppDrawer>
</template>
